import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "py-3 container-fluid space-y-3" }
const _hoisted_2 = { class: "grid grid-rows-4 md:grid-rows-2 md:grid-cols-2 lg:grid-rows-1 lg:grid-cols-4 gap-3" }
const _hoisted_3 = { class: "w-full bg-white rounded-lg p-3 flex items-center gap-2" }
const _hoisted_4 = { class: "flex items-center justify-center h-16 w-16 text-white rounded-md shadow bg-gradient-to-r from-[#424c42] to-[#647064]" }
const _hoisted_5 = { class: "flex flex-col justify-start" }
const _hoisted_6 = { class: "text-sm font-light text-gray-600" }
const _hoisted_7 = { class: "text-2xl font-bold leading-tight" }
const _hoisted_8 = { class: "w-full bg-white rounded-lg p-3 flex items-center gap-2" }
const _hoisted_9 = { class: "flex items-center justify-center h-14 w-14 text-white rounded-md shadow bg-gradient-to-r from-[#424c42] to-[#647064]" }
const _hoisted_10 = { class: "flex flex-col justify-start" }
const _hoisted_11 = { class: "text-sm font-light text-gray-600" }
const _hoisted_12 = { class: "text-2xl font-bold leading-tight" }
const _hoisted_13 = { class: "text-xs font-light text-gray-500" }
const _hoisted_14 = { class: "w-full bg-white rounded-lg p-3 flex items-center gap-2" }
const _hoisted_15 = { class: "flex items-center justify-center h-14 w-14 text-white rounded-md shadow bg-gradient-to-r from-[#424c42] to-[#647064]" }
const _hoisted_16 = { class: "flex flex-col justify-start" }
const _hoisted_17 = { class: "text-sm font-light text-gray-600" }
const _hoisted_18 = { class: "text-2xl font-bold leading-tight" }
const _hoisted_19 = { class: "text-xs font-light text-gray-500" }
const _hoisted_20 = { class: "w-full bg-white rounded-lg p-3 flex items-center gap-2" }
const _hoisted_21 = { class: "flex items-center justify-center h-14 w-14 text-white rounded-md shadow bg-gradient-to-r from-[#424c42] to-[#647064]" }
const _hoisted_22 = { class: "flex flex-col justify-start" }
const _hoisted_23 = { class: "text-sm font-light text-gray-600" }
const _hoisted_24 = { class: "text-2xl font-bold leading-tight" }
const _hoisted_25 = { class: "text-xs font-light text-gray-500" }
const _hoisted_26 = {
  key: 0,
  class: "text-sm md:text-md text-gray-500"
}
const _hoisted_27 = { class: "flex flex-col lg:flex-row gap-3" }
const _hoisted_28 = { class: "bg-white rounded-lg p-4 flex items-center gap-3 cursor-pointer hover:bg-gray-200" }
const _hoisted_29 = { class: "flex items-center justify-center text-gray-600" }
const _hoisted_30 = { class: "flex flex-col" }
const _hoisted_31 = { class: "text-xs font-light text-gray-400" }
const _hoisted_32 = { class: "text-sm leading-tight" }
const _hoisted_33 = {
  key: 1,
  class: "text-sm md:text-md text-gray-500"
}
const _hoisted_34 = { class: "flex flex-col gap-2" }
const _hoisted_35 = { class: "flex flex-col justify-start" }
const _hoisted_36 = { class: "text-sm font-bold text-gray-600" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "text-sm font-light text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far','handshake'],
            class: "text-xl"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('dashboard.total.citas')), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.dashboardMeeting?.totalCitas), 1),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-xs font-light text-gray-500" }, " ", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far','handshake'],
            class: "text-xl"
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('dashboard.citas.confirmadas')), 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.dashboardMeeting?.totalConfirmadas), 1),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.porcentajeAprobacion) + "% de confirmación", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far','handshake'],
            class: "text-xl"
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('dashboard.citas.pendientes')), 1),
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.dashboardMeeting?.totalPendientes), 1),
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.porcentajeAprobacion) + "% de pendientes", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far','handshake'],
            class: "text-xl"
          })
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('dashboard.citas.rechazadas')), 1),
          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.dashboardMeeting?.totalRechazadas), 1),
          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.porcentajeRechazadas) + "% de rechazo", 1)
        ])
      ])
    ]),
    (_ctx.dashboardMeeting?.pendientes?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.$t('dashboard.acciones.pendientes')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_27, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboardMeeting?.pendientes, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex-1"
        }, [
          _createVNode(_component_router_link, {
            class: "opacity-8",
            to: _ctx.getLink(item)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['far','fa-bell'],
                    class: "text-3xl fa-shake"
                  })
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(item.tipo), 1),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t(item.descripcion)), 1)
                ])
              ])
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ]),
    (_ctx.dashboardMeeting?.proximasCitas?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$t('dashboard.proximas.citas')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_34, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboardMeeting?.proximasCitas, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "w-full bg-white rounded-lg p-3 flex items-center gap-2"
        }, [
          _createElementVNode("div", {
            class: "flex items-center justify-center h-16 w-16 rounded-md border",
            style: _normalizeStyle({ borderColor: item.colorEstado, color: item.colorEstado })
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: _ctx.getIcono(item),
              class: "text-3xl"
            }, null, 8, ["icon"])
          ], 4),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("span", _hoisted_36, [
              _createTextVNode(_toDisplayString(item.cronograma?.horaDesde), 1),
              (item.contraparte)
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, " - " + _toDisplayString(item.contraparte.nombre) + " " + _toDisplayString(item.contraparte.apellido), 1))
                : _createCommentVNode("", true),
              (item.empresa && (item.empresa.nombreFantasia || item.empresa.razonSocial))
                ? (_openBlock(), _createElementBlock("span", _hoisted_38, " - " + _toDisplayString(item.empresa.nombreFantasia || item.empresa.razonSocial), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.formatDate(item?.cronograma?.fecha, 'dd/MM/yyyy')), 1),
            _createElementVNode("div", {
              class: "flex flex-wrap text-xs font-semibold",
              style: _normalizeStyle({ color: item.colorEstado })
            }, _toDisplayString(item.descripcionEstado), 5)
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_FullScreenLoader, { visible: _ctx.isSubmitting }, null, 8, ["visible"])
  ]))
}